import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@getgo/chameleon-web-react-wrapper';
import classes from './dialog.scss';
import { Box } from '@mui/material';

const DialogueView = ({
  onClosed,
  open,
  title,
  closable,
  actions,
  children,
  size
}) => {
  return (
    <Dialog
      open={open}
      size={size}
      title={title}
      closable={closable}
      onClosed={onClosed}
      closeButtonLabel="close"
      actions={actions}
    >
      <Box className={classes["dialogChildren"]}>
        {children}
      </Box>
    </Dialog>
  );
};

DialogueView.propTypes = {
  onClosed: PropTypes.func,
  children: PropTypes.element,
  size: PropTypes.string,
  open: PropTypes.bool.isRequired,
  title: PropTypes.object.isRequired,
  closable: PropTypes.bool,
  actions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool
  ])
};

export default DialogueView;
